export enum VehicleCheckDefaultOption {
  PASS = 'pass',
  WARNING = 'warning',
  FAIL = 'fail',
}

export interface IVehicleCheckDefaultOption {
  label: string;
  value: VehicleCheckDefaultOption;
}

export const VehicleCheckDefaultOptions: IVehicleCheckDefaultOption[] = [
  {
    label: 'Pass',
    value: VehicleCheckDefaultOption.PASS,
  },
  {
    label: 'Warning',
    value: VehicleCheckDefaultOption.WARNING,
  },
  {
    label: 'Fail',
    value: VehicleCheckDefaultOption.FAIL,
  },
];

export const getVehicleCheckDefaultOptionNameFromKey = (key: VehicleCheckDefaultOption) => {
  return VehicleCheckDefaultOptions.find((option) => option.value === key)?.label;
};
